export default class ProductCategoriesCarousel {
    constructor() {
        this.initCarousels();
    }

    initCarousels() {
        let parent = this,
            carousels = document.getElementsByClassName('products-categories-carousel');
        if ( 0 === carousels.length ) {
            return
        }
        Array.from(carousels).forEach((carousel) => {
            new Swiper(
                carousel.querySelector('.swiper'),
                {
                    loop: false,
                    spaceBetween: 15,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    slidesPerView: 1.5,
                    navigation: {
                        nextEl: carousel.querySelector('.swiper-button-next'),
                        prevEl: carousel.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        400: {
                            slidesPerView: 2.5,
                        },
                        782: {
                            slidesPerView: 3.5,
                        },
                        992: {
                            slidesPerView: 4.2,
                        },
                        1900: {
                            slidesPerGroup: 4,
                            slidesPerView: 'auto',
                        },
                    },
                    on: {
                        init: function(swiper) {
                            parent.fullSizeCarousel(swiper, 4);
                            swiper.navigation.nextEl.removeAttribute('disabled')
                            swiper.navigation.prevEl.removeAttribute('disabled')
                        },
                        resize: function(swiper) {
                            parent.fullSizeCarousel(swiper, 4);
                        }
                    }
                }
            );
        });
    }

    fullSizeCarousel(swiper, defaultNoOfSlides) {
        if( window.innerWidth > 1400 && swiper.slides.length > 4 ) {
            swiper.el.classList.add('swiper-container-fullwidth');
            const parentWrapper = swiper.el.parentElement.getBoundingClientRect()
            swiper.params.slidesOffsetBefore = parentWrapper.left;
            swiper.params.slidesOffsetAfter = parentWrapper.left;
            if (swiper.slides.length <= defaultNoOfSlides) {
                swiper.navigation.enabled = false
            }
        } else {
            swiper.params.slidesOffsetBefore = 0
            swiper.params.slidesOffsetAfter = 0
            swiper.el.classList.remove('swiper-container-fullwidth');
        }
    }
}
  

